import React, { useState, useCallback, useEffect, useRef } from "react";

import { loader } from "helpers";
import MultiPhotoUpload from "components/MultiPhotoUpload";
import AssignedOperators from "components/AssignedOperators";

import { Link, useParams, useHistory, useLocation } from "react-router-dom";
import styled from 'styled-components';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faMapMarkedAlt, faCamera, faCheck } from '@fortawesome/free-solid-svg-icons';
import { readAndCompressImage } from 'browser-image-resizer';

const statusLabels = {
	'pendiente_preparar': 'Pendiente preparar',
	'en_preparacion': 'En preparación',
	'preparado': 'Preparado',
	'enviado': 'Enviado',
};

const statusColors = {
	'pendiente_preparar': 'warning',
	'en_preparacion': 'info',
	'preparado': 'success',
	'enviado': 'primary',
};

const ContainerStyled = styled.div`

	#loading-cristal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background: rgba(255,255,255,0.5);
		z-index: 999;

		#loader {
			width: 100px;
		}
	}

	.page-title {
		text-align: center;
		position: relative;

		#back-button {
			position: absolute;
			left: 0;
			top: 5px;
		}
	}

	.property-wrapper {
		position: relative;

		.map-btn {
			position: absolute;
			right: 0;
			bottom: 0;
			color: white;
		}
	}

	.system-group {
		margin-bottom: 20px;

		.system-group-header {
			font-weight: 700;
			font-size: 15px;
			margin-bottom: 4px;
		}

		.system-group-meta {
			font-size: 13px;
			color: #6c757d;
			margin-bottom: 8px;

			.ref-link {
				color: var(--bs-primary);
				cursor: pointer;
				text-decoration: underline;
				font-weight: 600;

				&:hover {
					color: var(--bs-primary);
					opacity: 0.8;
				}
			}
		}
	}

	.modal-backdrop-custom {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.5);
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px;
	}

	.modal-content-custom {
		background: white;
		border-radius: 10px;
		width: 95%;
		max-height: 95vh;
		overflow-y: auto;
		padding: 10px;
		position: relative;

		.modal-close {
			position: absolute;
			top: 10px;
			right: 15px;
			background: none;
			border: none;
			font-size: 24px;
			font-weight: bold;
			cursor: pointer;
			color: #6c757d;
		}

		.modal-title {
			font-weight: 700;
			font-size: 16px;
			margin-bottom: 15px;
			padding-right: 30px;
		}

		.detail-row {
			font-size: 13px;
			margin-bottom: 4px;
		}

		.detail-subitems-table {
			width: 100%;
			font-size: 12px;
			border-collapse: collapse;
			margin-top: 10px;

			th, td {
				border: 1px solid #dee2e6;
				padding: 5px 8px;
			}

			th {
				background: #f8f9fa;
				font-weight: 700;
			}
		}
	}

	.subitems-table {
		width: 100%;
		font-size: 13px;
		border-collapse: collapse;

		th, td {
			border: 1px solid #dee2e6;
			padding: 6px 8px;
			vertical-align: middle;
		}

		th {
			background: #f8f9fa;
			font-weight: 700;
			font-size: 12px;
		}

		.col-ref { width: 20%; }
		.col-article { }
		.col-ud { width: 50px; text-align: center; }
		.col-actions { width: 50px; text-align: center; vertical-align: middle; }

		.check-btn {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			padding: 0;
		}

		.photo-btn {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			padding: 0;
		}

		.check-info {
			font-size: 10px;
			color: #6c757d;
			text-align: left;
			display: block;
		}

		.check-photo-thumb {
			max-width: 40px;
			max-height: 40px;
			border-radius: 3px;
			cursor: pointer;
			display: block;
			margin: 4px 0 0;
		}

		.check-photo-wrapper {
			position: relative;
			display: inline-block;
			margin-top: 8px;
		}

		.delete-photo-btn {
			position: absolute;
			top: -5px;
			right: -5px;
			background: var(--bs-danger);
			color: white;
			border: none;
			border-radius: 50%;
			width: 18px;
			height: 18px;
			font-size: 12px;
			line-height: 12px;
			padding: 0;
			cursor: pointer;
		}
	}

	.upload-file-hidden {
		opacity: 0;
		width: 0;
		height: 0;
	}
`;

let cancelTokenSource = null;
let saveTimeout = null;

export default function LogisticsDetail() {
	let { id } = useParams();
	const location = useLocation();
	const section = new URLSearchParams(location.search).get('section') || 'supply';
	let history = useHistory();

	// State
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [transportAgencies, setTransportAgencies] = useState([]);
	const [refModal, setRefModal] = useState(null);

	const loadData = useCallback(() => {
		setData(null);
		setLoading(true);

		axios.get('api/logistics/get/' + id, {
			params: {},
			cancelToken: cancelTokenSource.token
		}).then((response) => {
			setData(response.data);
		}).catch((error) => {
			toast.error('Error al cargar los datos, por favor, vuelve a intentarlo');
		}).then(() => {
			setLoading(false);
		});
	}, [id]);

	const loadTransportAgencies = useCallback(() => {
		axios.get('api/logistics/transport-agencies', {
			cancelToken: cancelTokenSource.token
		}).then((response) => {
			setTransportAgencies(response.data);
		}).catch(() => {});
	}, []);

	useEffect(() => {
		cancelTokenSource = axios.CancelToken.source();
		loadData();
		loadTransportAgencies();

		return function cleanup() {
			cancelTokenSource.cancel();
			if (saveTimeout) clearTimeout(saveTimeout);
		}
	}, [loadData, loadTransportAgencies]);

	// --- Save helpers ---
	const saveField = (field, value) => {
		axios.post('api/logistics/save/' + id, {
			[field]: value
		}, {
			cancelToken: cancelTokenSource.token
		}).catch(() => {
			toast.error('Error al guardar');
		});
	};

	const onTransportAgencyChange = (e) => {
		let val = e.target.value || null;
		setData({ ...data, transport_agency_id: val });
		saveField('transport_agency_id', val);
	};

	const onExpectedDeliveryDateChange = (e) => {
		let val = e.target.value || null;
		setData({ ...data, expected_delivery_date: val });
		if (saveTimeout) clearTimeout(saveTimeout);
		saveTimeout = setTimeout(() => saveField('expected_delivery_date', val), 500);
	};

	// --- Subitem check actions ---
	const toggleSubitemCheck = (subitemId, currentChecked, systemIdx, subitemIdx) => {
		setLoading(true);
		axios.post('api/logistics/set-subitem-check/' + subitemId, {
			checked: !currentChecked
		}, {
			cancelToken: cancelTokenSource.token
		}).then((response) => {
			updateSubitemCheck(systemIdx, subitemIdx, response.data.check);
		}).catch(() => {
			toast.error('Error al marcar el check');
		}).then(() => {
			setLoading(false);
		});
	};

	const uploadSubitemCheckPhoto = (subitemId, blob, systemIdx, subitemIdx) => {
		let formData = new FormData();
		formData.append('file', blob, 'camera photo');

		setLoading(true);
		axios.post('api/logistics/upload-subitem-check-photo/' + subitemId, formData, {
			header: { 'Content-Type': 'multipart/form-data' },
			cancelToken: cancelTokenSource.token
		}).then((response) => {
			updateSubitemCheck(systemIdx, subitemIdx, response.data.check);
		}).catch(() => {
			toast.error('Error al subir la foto');
		}).then(() => {
			setLoading(false);
		});
	};

	const deleteSubitemCheckPhoto = (subitemId, systemIdx, subitemIdx) => {
		let c = window.confirm('¿Seguro que quieres eliminar la foto? Se desmarcará el check.');
		if (!c) return;

		setLoading(true);
		axios.post('api/logistics/delete-subitem-check-photo/' + subitemId, {}, {
			cancelToken: cancelTokenSource.token
		}).then((response) => {
			updateSubitemCheck(systemIdx, subitemIdx, response.data.check);
		}).catch(() => {
			toast.error('Error al eliminar la foto');
		}).then(() => {
			setLoading(false);
		});
	};

	const updateSubitemCheck = (systemIdx, subitemIdx, check) => {
		let systems = [...data.systems_summary];
		systems[systemIdx] = { ...systems[systemIdx] };
		systems[systemIdx].subitems = [...systems[systemIdx].subitems];
		systems[systemIdx].subitems[subitemIdx] = { ...systems[systemIdx].subitems[subitemIdx], logistics_check: check };
		setData({ ...data, systems_summary: systems });
	};

	// --- Photo upload/delete for work order photos ---
	const uploadWorkOrderPhoto = (type, blob) => {
		let formData = new FormData();
		formData.append('file', blob, 'camera photo');
		formData.append('type', type);

		setLoading(true);
		axios.post('api/logistics/upload-photo/' + id, formData, {
			header: { 'Content-Type': 'multipart/form-data' },
			cancelToken: cancelTokenSource.token
		}).then((response) => {
			let photo = response.data.photo;
			let key = type === 'packaging' ? 'packaging_photos' : type === 'loading' ? 'loading_photos' : 'agency_receipt_photos';
			setData({ ...data, [key]: [...(data[key] || []), photo] });
		}).catch(() => {
			toast.error('Error al subir la foto');
		}).then(() => {
			setLoading(false);
		});
	};

	const deleteWorkOrderPhoto = (type, photoId) => {
		setLoading(true);
		axios.post('api/logistics/delete-photo/' + photoId, {}, {
			cancelToken: cancelTokenSource.token
		}).then(() => {
			let key = type === 'packaging' ? 'packaging_photos' : type === 'loading' ? 'loading_photos' : 'agency_receipt_photos';
			setData({ ...data, [key]: (data[key] || []).filter(p => p.id !== photoId) });
		}).catch(() => {
			toast.error('Error al eliminar la foto');
		}).then(() => {
			setLoading(false);
		});
	};

	// --- Status change ---
	const changeStatus = (newStatus) => {
		let message = newStatus === 'preparado'
			? '¿Seguro que quieres marcar este parte como PREPARADO?'
			: '¿Seguro que quieres marcar este parte como ENVIADO?';

		if (!window.confirm(message)) return;

		setLoading(true);
		axios.post('api/logistics/change-status/' + id, {
			status: newStatus
		}, {
			cancelToken: cancelTokenSource.token
		}).then(() => {
			toast.success('Estado actualizado correctamente');
			loadData();
		}).catch((error) => {
			let msg = error.response?.data?.message || 'Error al cambiar el estado';
			toast.error(msg);
		}).then(() => {
			setLoading(false);
		});
	};

	// Generate property map url
	let property_map_url = "https://www.google.com/maps/search/?api=1&query=";
	if (data?.property?.province) property_map_url += data.property?.province;
	if (data?.property?.city) property_map_url += " " + data.property?.city;
	if (data?.property?.postalcode) property_map_url += " " + data.property?.postalcode;
	if (data?.property?.address) property_map_url += " " + data.property?.address;

	// Is readonly (enviado)
	let isReadonly = data?.logistics_status === 'enviado';
	// Checks locked once preparado or enviado
	let checksLocked = data?.logistics_status === 'preparado' || data?.logistics_status === 'enviado';

	// Type label
	let typeLabel = '';
	if (data) {
		if (data.type === 'new') typeLabel = 'Nueva instalación';
		else if (data.type === 'maintenance') typeLabel = 'Mantenimiento';
		else if (data.type === 'supply') typeLabel = 'Suministro';
		else typeLabel = data.type;
	}

	// Render
	return (
		<ContainerStyled className="container">
			{loading &&
				<div id="loading-cristal">
					{loader()}
				</div>
			}
			<div className="row">
				<div className="col-md-12">
					<div className="page-title">
						<Link to={"/logistics-plans/" + (data?.logistics_status || 'en_preparacion') + "?section=" + section} className="btn btn-primary" id="back-button"><FontAwesomeIcon icon={faChevronLeft} /></Link>
						<h4 className="p-0 m-0 py-2">{section === 'logistics' ? 'Ficha logística' : 'Ficha suministro'}</h4>
					</div>
					{data &&
						<React.Fragment>
							{/* Header */}
							<div className="col-md-12 mt-3">
								<div className="card">
									<div className="card-body">
										<div className="d-flex justify-content-between align-items-start">
											<h4 className="m-0 mb-2 text-success">REF.: {data.code}</h4>
											<span className={"badge bg-" + (statusColors[data.logistics_status] || 'secondary') + (data.logistics_status === 'pendiente_preparar' ? ' text-dark' : ' text-white')}>
												{statusLabels[data.logistics_status] || data.logistics_status}
											</span>
										</div>

										<div><b>Tipo:</b> {typeLabel}</div>
										<div><b>Fecha preparación:</b> {moment(data.installation_date).format('DD-MM-YYYY')}</div>

										<hr />

										<div><b>Dirección de entrega</b></div>
										<div className="property-wrapper">
											<div>{data.property?.name}</div>
											<div>{data.property?.address}</div>
											<div>{data.property?.province} {data.property?.city} {data.property?.postalcode}</div>
											<div><b>Franja horaria:</b> {data.construction?.time}</div>
											<div><b>Persona de contacto:</b> {data.construction?.name}</div>
											<div><a href={'tel:' + data.construction?.phone}>{data.construction?.phone}</a></div>
											<a href={property_map_url} target="_blank" rel="noreferrer" className="btn btn-primary btn-lg map-btn"><FontAwesomeIcon icon={faMapMarkedAlt} /></a>
										</div>

										<hr />

										<div><b>Cliente</b></div>
										<div>
											<div>{data.client?.name}</div>
											<div><a href={'tel:' + data.client?.phone}>{data.client?.phone}</a></div>
										</div>

										{data.observations && !!data.show_observations &&
											<React.Fragment>
												<hr />
												<div><b>Observaciones</b></div>
												<div style={{fontSize: 13, whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: data.observations}} />
											</React.Fragment>
										}
									</div>
								</div>
							</div>

							<AssignedOperators operators={data.assigned_operators} className="col-md-12 mt-3" />

							{/* Systems summary */}
							<div className="col-md-12 mt-3">
								<div className="card">
									<div className="card-body">
										<h5 className="mb-3">Resumen de sistemas</h5>
										{data.systems_summary && data.systems_summary.map((system, systemIdx) => (
											<div className="system-group" key={systemIdx}>
												<div className="system-group-header">
									{system.model_name}
									{system.covertypes && system.covertypes.length > 0 &&
										<span className="text-muted"> - {[...new Set(system.covertypes)].join(', ')}</span>
									}
								</div>
												<div className="system-group-meta">
													{system.meters && system.meters.length > 0 &&
														<span>({system.meters.join(' + ')}) metros &middot; </span>
													}
													REF: {system.refs.map((ref, refIdx) => (
														<React.Fragment key={refIdx}>
															{refIdx > 0 && ', '}
															<span className="ref-link" onClick={() => {
																let detail = data.items_detail?.find(d => d.reference === ref);
																if (detail) setRefModal(detail);
															}}>{ref}</span>
														</React.Fragment>
													))}
												</div>

												{system.subitems && system.subitems.length > 0 ?
													<table className="subitems-table">
														<thead>
															<tr>
																<th className="col-ref">REF</th>
																<th className="col-article">ARTÍCULO</th>
																<th className="col-ud">UD</th>
																<th className="col-actions"></th>
															</tr>
														</thead>
														<tbody>
															{system.subitems.map((sub, subIdx) => (
																<SubitemRow
																	key={sub.subitem_id}
																	sub={sub}
																	disabled={checksLocked}
																	onToggleCheck={() => toggleSubitemCheck(sub.subitem_id, sub.logistics_check?.checked, systemIdx, subIdx)}
																	onUploadPhoto={(blob) => uploadSubitemCheckPhoto(sub.subitem_id, blob, systemIdx, subIdx)}
																	onDeletePhoto={() => deleteSubitemCheckPhoto(sub.subitem_id, systemIdx, subIdx)}
																/>
															))}
														</tbody>
													</table>
													:
													<div className="text-muted" style={{fontSize: 13}}>No hay despiece</div>
												}
											</div>
										))}
									</div>
								</div>
							</div>

							{/* Transport agency */}
							<div className="col-md-12 mt-3">
								<div className="card">
									<div className="card-body">
										<label className="fw-bold mb-1">Agencia de transporte</label>
										<select
											className="form-select"
											value={data.transport_agency_id || ''}
											onChange={onTransportAgencyChange}
											disabled={isReadonly}
										>
											<option value="">-- Seleccionar --</option>
											{transportAgencies.map(a => (
												<option key={a.id} value={a.id}>{a.name}</option>
											))}
										</select>
									</div>
								</div>
							</div>

							{/* Photos sections */}
							<div className="col-md-12 mt-3">
								<div className="card">
									<div className="card-body">
										<MultiPhotoUpload
											label="Foto albarán agencia"
											photos={data.agency_receipt_photos || []}
											onUpload={(blob) => uploadWorkOrderPhoto('agency_receipt', blob)}
											onDelete={(photoId) => deleteWorkOrderPhoto('agency_receipt', photoId)}
											disabled={isReadonly}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-12 mt-3">
								<div className="card">
									<div className="card-body">
										<MultiPhotoUpload
											label="Foto material embalado"
											photos={data.packaging_photos || []}
											onUpload={(blob) => uploadWorkOrderPhoto('packaging', blob)}
											onDelete={(photoId) => deleteWorkOrderPhoto('packaging', photoId)}
											disabled={isReadonly}
										/>
									</div>
								</div>
							</div>

							<div className="col-md-12 mt-3">
								<div className="card">
									<div className="card-body">
										<MultiPhotoUpload
											label="Foto de la carga"
											photos={data.loading_photos || []}
											onUpload={(blob) => uploadWorkOrderPhoto('loading', blob)}
											onDelete={(photoId) => deleteWorkOrderPhoto('loading', photoId)}
											disabled={isReadonly}
										/>
									</div>
								</div>
							</div>

							{/* Expected delivery date */}
							<div className="col-md-12 mt-3">
								<div className="card">
									<div className="card-body">
										<label className="fw-bold mb-1">Fecha prevista de entrega</label>
										<input
											type="date"
											className="form-control"
											value={data.expected_delivery_date || ''}
											onChange={onExpectedDeliveryDateChange}
											disabled={isReadonly}
										/>
									</div>
								</div>
							</div>

							{/* Action button */}
							{data.logistics_status === 'en_preparacion' &&
								(() => {
									let allChecked = data.systems_summary?.every(s => s.subitems?.every(sub => sub.logistics_check?.checked));
									return (
										<div className="col-md-12 mt-3 mb-3">
											{!allChecked &&
												<div className="alert alert-warning text-center py-2" style={{fontSize: 13}}>
													No se puede marcar como preparado sin antes marcar todos los checks
												</div>
											}
											<button className="btn btn-success btn-lg w-100" disabled={!allChecked} onClick={() => changeStatus('preparado')}>
												MARCAR COMO PREPARADO
											</button>
										</div>
									);
								})()
							}

							{data.logistics_status === 'preparado' &&
								(() => {
									let missingItems = [];
									if (!data.transport_agency_id) missingItems.push('agencia de transporte');
									if (!data.agency_receipt_photos || data.agency_receipt_photos.length === 0) missingItems.push('foto del albarán');
									if (!data.loading_photos || data.loading_photos.length === 0) missingItems.push('foto de la carga');
									let canSend = missingItems.length === 0;
									return (
										<div className="col-md-12 mt-3 mb-3">
											{!canSend &&
												<div className="alert alert-warning text-center py-2" style={{fontSize: 13}}>
													Falta: {missingItems.join(', ')}
												</div>
											}
											<button className="btn btn-primary btn-lg w-100" disabled={!canSend} onClick={() => changeStatus('enviado')}>
												MARCAR COMO ENVIADO
											</button>
										</div>
									);
								})()
							}

						</React.Fragment>
					}
				</div>
			</div>

			{/* REF Detail Modal */}
			{refModal &&
				<div className="modal-backdrop-custom" onClick={() => setRefModal(null)}>
					<div className="modal-content-custom" onClick={(e) => e.stopPropagation()}>
						<button className="modal-close" onClick={() => setRefModal(null)}>&times;</button>
						<div className="modal-title">{refModal.reference} - {refModal.model_name}</div>

						<div className="detail-row"><b>Referencia:</b> {refModal.reference}</div>
						<div className="detail-row"><b>Tipo producto:</b> {refModal.product_type}</div>
						{refModal.concept ? <div className="detail-row"><b>Concepto:</b> {refModal.concept}</div> : null}
						{refModal.meters ? <div className="detail-row"><b>Longitud:</b> {refModal.meters} m</div> : null}
						{refModal.covertype ? <div className="detail-row"><b>Cubierta:</b> {refModal.covertype}</div> : null}
						{refModal.ubication ? <div className="detail-row"><b>Ubicación:</b> {refModal.ubication}</div> : null}
						<div className="detail-row"><b>Unidades:</b> {refModal.units}</div>
						{refModal.lineavida_type ? <div className="detail-row"><b>Tipo línea de vida:</b> {refModal.lineavida_type}</div> : null}

						{refModal.subitems && refModal.subitems.length > 0 &&
							<table className="detail-subitems-table">
								<thead>
									<tr>
										<th>REF</th>
										<th>ARTÍCULO</th>
										<th>UD</th>
									</tr>
								</thead>
								<tbody>
									{refModal.subitems.map((sub, idx) => (
										<tr key={idx}>
											<td>{sub.article_code}</td>
											<td>{sub.article_name}</td>
											<td>{sub.units}</td>
										</tr>
									))}
								</tbody>
							</table>
						}
					</div>
				</div>
			}
		</ContainerStyled>
	);
}


// --- SubitemRow: a row in the subitems table with check + photo ---
function SubitemRow({ sub, disabled, onToggleCheck, onUploadPhoto, onDeletePhoto }) {
	let fileRef = useRef(null);

	const handlePhotoChange = async (e) => {
		let file = e.target.files[0];
		if (!file) return;

		let allowed = "png jpg jpeg gif bmp";
		let extension = file.type.substring(file.type.indexOf('/') + 1);
		if (!extension.length || allowed.indexOf(extension) === -1) {
			toast.error("Extensión no válida. Solo se permiten: " + allowed.replaceAll(' ', ', '));
			e.target.value = null;
			return;
		}

		await readAndCompressImage(file, {
			quality: 0.9,
			maxWidth: 800,
			maxHeight: 600,
			autoRotate: true,
		}).then(resizedImage => {
			onUploadPhoto(resizedImage);
		});

		e.target.value = null;
	};

	let check = sub.logistics_check;
	let isChecked = check?.checked || false;

	return (
		<tr>
			<td className="col-ref">{sub.article_code}</td>
			<td className="col-article">
				<div>{sub.article_name}</div>
				{check?.photo_base64 &&
					<div className="check-photo-wrapper">
						<img
							src={check.photo_base64}
							alt="check"
							className="check-photo-thumb"
							onClick={() => {
								let w = window.open('');
								w.document.write('<img src="' + check.photo_base64 + '" style="max-width:100%;" />');
							}}
						/>
						{!disabled &&
							<button className="delete-photo-btn" onClick={onDeletePhoto}>&times;</button>
						}
					</div>
				}
				{isChecked && check?.checked_at &&
					<span className="check-info">{moment(check.checked_at).format('DD-MM-YYYY HH:mm')}</span>
				}
			</td>
			<td className="col-ud">{sub.units}</td>
			<td className="col-actions">
				{!disabled &&
					<React.Fragment>
						<button className="btn btn-outline-primary photo-btn" onClick={() => fileRef.current.click()}>
							<FontAwesomeIcon icon={faCamera} />
						</button>
						<input type="file" className="upload-file-hidden" onChange={handlePhotoChange} ref={fileRef} />
					</React.Fragment>
				}
				<button
					className={"btn check-btn mt-1 " + (isChecked ? 'btn-success' : 'btn-outline-secondary')}
					onClick={() => !disabled && onToggleCheck()}
					disabled={disabled}
				>
					<FontAwesomeIcon icon={faCheck} />
				</button>
			</td>
		</tr>
	);
}
